import "../../assets/styles/product-view.css";
import React, { useEffect } from "react";
import image from "../../assets/images/spot_banner.jpeg";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Banner from "../../components/Banner/Banner";
import product_image from "../../assets/images/SPOT.jpg";
import { FormattedMessage } from "react-intl";
import Team from "../../components/Team/Team";
import MatchingProducts from "../../components/MatchingProducts/MatchingProducts";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLang } from "../../redux/actions/settings";

const SPOT = () => {
  const { language } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (language === "de" || language === "en") {
      dispatch(setLang(language));
    } else {
      navigate("/not-found");
    }
  }, []);

  useEffect(() => {
    document.title = "SPOT";
  }, []);

  window.scrollTo(0, 0);

  const gotoSPOT = (e) => {
    e.preventDefault();
    if (window.location.host.includes("localhost")) {
      window.location.href = "https://dev.eclear-solutions.com/signup";
    } else {
      window.location.href = "/";
    }
  };

  return (
    <div>
      <div>
        <BreadCrumbs
          navItems={[
            {
              title: "eClear Store",
              href: `/store/${language}`,
            },
            {
              title: "VAT Suite",
              href: `/store/${language}/vat-suite`,
            },
            {
              title: "SPOT",
            },
          ]}
        />
      </div>
      <div>
        <div>
          <div className="column main">
            <Banner image={image} title={"SPOT"} productImage={product_image} />
            <input
              name="form_key"
              type="hidden"
              defaultValue="Sk3VlxqpWwfVfRQk"
            />
            <div
              id="authenticationPopup"
              data-bind="scope:'authenticationPopup', style: {display: 'none'}"
              style={{ display: "none" }}
            ></div>
            <div className="catalog-product-view ">
              <div className="product-infomation-wrapper">
                <input type="hidden" id="storeId" defaultValue={1} />
                <input type="hidden" id="currencySymbol" defaultValue="€" />
                <div className="product-information">
                  <div className="box-left">
                    <div className="use-case">
                      <h3 className="title">Use case</h3>
                      <FormattedMessage
                        id="SPOT.useCase"
                        values={{
                          sup: (...chunks) => {
                            return <sup>{chunks}</sup>;
                          },
                        }}
                      />
                    </div>
                    <div className="features-and-benefits">
                      <div className="features">
                        <h3 className="title">Feature</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage
                              id="SPOT.feature1"
                              values={{
                                sup: (...chunks) => {
                                  return <sup>{chunks}</sup>;
                                },
                              }}
                            />
                          </li>
                          <li>
                            <FormattedMessage id="SPOT.feature2" />
                          </li>
                          <li>
                            <FormattedMessage id="SPOT.feature3" />
                          </li>
                        </ul>{" "}
                      </div>
                      <div className="benefits">
                        <h3 className="title">Benefit</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage
                              id="SPOT.benefit1"
                              values={{
                                sup: (...chunks) => {
                                  return <sup>{chunks}</sup>;
                                },
                              }}
                            />
                          </li>
                          <li>
                            <FormattedMessage id="SPOT.benefit2" />
                          </li>
                          <li>
                            <FormattedMessage id="SPOT.benefit3" />
                          </li>
                          <li>
                            <FormattedMessage id="SPOT.benefit4" />
                          </li>
                          <li>
                            <FormattedMessage id="SPOT.benefit5" />
                          </li>
                        </ul>{" "}
                      </div>
                    </div>
                    <Team />
                  </div>
                  <div className="box-right">
                    {/* REQUEST BUTTON */}
                    <form>
                      {/* <form action="https://eclear.com/contact/" method="post"> */}
                      <div className="box-to-cart">
                        <span>
                          <FormattedMessage id="Request quotation" />
                        </span>
                        <button
                          className="action subscribe primary request-demo-now-header"
                          type="submit"
                          onClick={gotoSPOT}
                        >
                          <FormattedMessage id="Get SPOT" />
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <MatchingProducts />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SPOT;
